var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStatistics = function SvgStatistics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "statistics")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,44H27a1,1,0,0,1-1-1V33a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1V43A1,1,0,0,1,33,44Z",
    fill: "#ffd764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,4a4,4,0,0,0-4,4,3.957,3.957,0,0,0,.566,2.02L32.02,16.566a3.888,3.888,0,0,0-4.04,0L21.434,10.02A3.957,3.957,0,0,0,22,8a4,4,0,0,0-8,0,3.957,3.957,0,0,0,.566,2.02L8.02,16.566A3.957,3.957,0,0,0,6,16a4,4,0,1,0,4,4,3.957,3.957,0,0,0-.566-2.02l6.546-6.546a3.888,3.888,0,0,0,4.04,0l6.546,6.546A3.957,3.957,0,0,0,26,20a4,4,0,0,0,8,0,3.957,3.957,0,0,0-.566-2.02l6.546-6.546A3.957,3.957,0,0,0,42,12a4,4,0,0,0,0-8Z",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,44H3a1,1,0,0,1-1-1V33a1,1,0,0,1,1-1H9a1,1,0,0,1,1,1V43A1,1,0,0,1,9,44Z",
    fill: "#ffd764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,44H15a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1V43A1,1,0,0,1,21,44Z",
    fill: "#1fd6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,44H39a1,1,0,0,1-1-1V23a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1V43A1,1,0,0,1,45,44Z",
    fill: "#1fd6aa"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatistics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/statistics.532aca64.svg";
export { ForwardRef as ReactComponent };